import { render, staticRenderFns } from "./EditDeleteProject.vue?vue&type=template&id=028ba1ad&"
import script from "./EditDeleteProject.vue?vue&type=script&lang=js&"
export * from "./EditDeleteProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports